import { render, staticRenderFns } from "./message-revoked.vue?vue&type=template&id=0b1c9606&scoped=true"
import script from "./message-revoked.vue?vue&type=script&lang=ts"
export * from "./message-revoked.vue?vue&type=script&lang=ts"
import style0 from "./message-revoked.vue?vue&type=style&index=0&id=0b1c9606&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b1c9606",
  null
  
)

export default component.exports